import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons/faArrowLeft';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-light-svg-icons/faArrowUpRightFromSquare';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { noop } from 'rxjs';
import classnames from 'classnames';

import { Button } from 'ui-components/components/button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';

import { ENHANCED_RETURNS_MODAL_PATH } from '../enhanced-returns-activation-step-detective';

import messages from '../messages';

import style from './style.module.less';

export const ActivationModalContent = ({ className, children }) => (
  <div className={classnames(style.activationModalContent, className)}>{children}</div>
);

export const ActivationModalFooter = ({
  disabled = false,
  loading = false,
  primaryText,
  onClickBackButton,
  onClickPrimaryButton = noop,
  onClickSecondaryButton,
  primaryButtonIcon = false,
  secondaryText = messages.cancel,
  showBackButton = true,
}) => {
  const history = useHistory();

  const onClickBack = () => {
    if (onClickBackButton) {
      onClickBackButton();
    } else {
      // load store list
      history.push(ENHANCED_RETURNS_MODAL_PATH);
    }
  };

  const onClickSecondary = () => {
    if (onClickSecondaryButton) {
      onClickSecondaryButton();
    } else {
      // load store list
      history.push(ENHANCED_RETURNS_MODAL_PATH);
    }
  };

  return (
    <ModalFooter className={style.activationModalFooter}>
      <Button
        className={classnames(style.backButton, {
          [style.disabledButton]: disabled,
          [style.hidden]: !showBackButton,
        })}
        disabled={disabled}
        onClick={onClickBack}
        theme='link'
      >
        <FontAwesomeIcon icon={faArrowLeft} />
        <FormattedMessage {...messages.backButton} />
      </Button>

      <div>
        <Button
          className={classnames(style.secondaryButton, {
            [style.disabledButton]: disabled,
          })}
          disabled={disabled}
          onClick={onClickSecondary}
          theme='tertiary'
        >
          <FormattedMessage {...secondaryText} />
        </Button>

        <Button
          className={classnames(style.primaryButton, {
            [style.disabledButton]: disabled,
          })}
          disabled={disabled}
          isLoading={loading}
          onClick={onClickPrimaryButton}
          theme={loading ? 'tertiary' : 'primary'}
        >
          <FormattedMessage {...primaryText} />
          {!loading && primaryButtonIcon && <FontAwesomeIcon className={style.primaryButtonIcon} icon={faArrowUpRightFromSquare} />}
        </Button>
      </div>
    </ModalFooter>
  );
};
